import { List } from 'immutable';
import { portfolioCompanyConnectionConstants } from '../constants';

export function portfolio_company_connections(state = {}, action) {
  switch (action.type) {
    case portfolioCompanyConnectionConstants.PORTFOLIO_COMPANY_CONNECTION_LIST_LOADING:
      return {
        ...state,
        items: null,
        listLoading: true
      };
    case portfolioCompanyConnectionConstants.PORTFOLIO_COMPANY_CONNECTION_LIST_SUCCESS:
      return {
        ...state,
        items: List(action.response),
        listLoading: false
      };
    case portfolioCompanyConnectionConstants.PORTFOLIO_COMPANY_CONNECTION_LIST_FAILURE:
      return {
        ...state,
        listLoading: false,
        items: null,
        listError: action.error
      };
    case portfolioCompanyConnectionConstants.PORTFOLIO_COMPANY_CONNECTION_CREATE_LOADING:
      return {
        ...state,
        createLoading: true
      };
    case portfolioCompanyConnectionConstants.PORTFOLIO_COMPANY_CONNECTION_CREATE_SUCCESS: {
      const items = state.items ? state.items : List();
      return {
        ...state,
        items: items.push(action.response),
        createLoading: false,
        createError: null
      };
    }
    case portfolioCompanyConnectionConstants.PORTFOLIO_COMPANY_CONNECTION_CREATE_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.error
      };

    case portfolioCompanyConnectionConstants.PORTFOLIO_COMPANY_CONNECTION_EDIT_LOADING:
      return {
        ...state,
        editLoading: true
      };
    case portfolioCompanyConnectionConstants.PORTFOLIO_COMPANY_CONNECTION_EDIT_SUCCESS: {
      if (!state.items) {
        return state;
      }

      const portfolioCompanyConnectionIndex = state.items.findIndex(
        val => val.id == action.response.id
      );

      if (portfolioCompanyConnectionIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.set(portfolioCompanyConnectionIndex, action.response),
        editLoading: false,
        editError: null
      };
    }
    case portfolioCompanyConnectionConstants.PORTFOLIO_COMPANY_CONNECTION_EDIT_FAILURE:
      return {
        ...state,
        editLoading: false,
        editError: action.error
      };

    case portfolioCompanyConnectionConstants.PORTFOLIO_COMPANY_CONNECTION_DELETE_LOADING:
      return {
        ...state,
        deleteLoading: true
      };
    case portfolioCompanyConnectionConstants.PORTFOLIO_COMPANY_CONNECTION_DELETE_SUCCESS: {
      const { portfolioCompanyConnectionId } = action;

      if (!state.items) {
        return state;
      }

      const portfolioCompanyConnectionIndex = state.items.findIndex(
        val => val.id == portfolioCompanyConnectionId
      );

      if (portfolioCompanyConnectionIndex == -1) {
        return state;
      }

      return {
        ...state,
        items: state.items.delete(portfolioCompanyConnectionIndex),
        deleteLoading: false,
        deleteError: null
      };
    }
    case portfolioCompanyConnectionConstants.PORTFOLIO_COMPANY_CONNECTION_DELETE_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.error
      };

    default:
      return state;
  }
}
